import permissionsApi from 'api-client/permissions';

const permissionsModule = {
  state: {
    permissions: []
  },
  getters: {
    permissions: state => state.permissions
  },
  mutations: {
    setPermissions(state, permissions) {
      state.permissions = permissions;
    }
  },
  actions: {
    async fetchPermissions({commit}) {
      commit('setPermissions', []);
      return await permissionsApi.fetchPermissions()
        .then((response) => {
          commit('setPermissions', response.permissions);
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            throw err.response.data.message;
          }

          throw err;
        });
    }
  }
};

export default permissionsModule;